import { WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Actions from '../actions/imstat';
import { IRootState } from '../reducers';
import SearchScenarioFactory from '../scenario/SearchScenarioFactory';
import CardPagination from './CardPagenation';
import DistanceLearningCard from './DistanceLearningCard';

export enum DistanceLearningTypes {
	ONGOING,
	RESULT,
}

const styles = (theme: Theme) =>
	createStyles({
		card: {
			height: '100%',
			width: 200,
		},
		content: {
			padding: theme.spacing(1),
		},
		distanceLearningTitle: {
			color: theme.palette.primary.main,
			fontSize: '108%',
			marginBottom: theme.spacing(1),
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		media: {
			height: 0,
			paddingTop: '56.25%',
		},
		pagination: {
			marginTop: theme.spacing(2),
		},
		root: {
			flexGrow: 1,
			padding: 24,
		},
	});

interface IState {
	startRowIndex: number;
	endRowIndex: number;
}

/**
 * 通信教育形式
 */
class ImstatDistanceLearningCard extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			endRowIndex: 4,
			startRowIndex: 0,
		};
	}

	public render() {
		const displayData = this.getDisplayData();
		return (
			<>
				<Grid
					container={true}
					spacing={1}
					direction="row"
					justify="center"
					alignItems="stretch"
				>
					{this.props.type === DistanceLearningTypes.ONGOING &&
						(displayData as Actions.IOnGoingDistanceLearning[]).map(
							(datum, i) => (
								<Grid key={i} item={true}>
									<DistanceLearningCard
										IOnGoingData={datum}
										type={this.props.type}
									/>
								</Grid>
							)
						)}
					{this.props.type === DistanceLearningTypes.RESULT &&
						(displayData as Actions.IResultDistanceLearning[]).map(
							(datum, i) => (
								<Grid key={i} item={true}>
									<DistanceLearningCard
										IResultData={datum}
										type={this.props.type}
									/>
								</Grid>
							)
						)}
				</Grid>
				<CardPagination
					onPageChange={this.handleChangePage}
					dataSize={this.props.data.length}
					className={this.props.classes.pagination}
				/>
			</>
		);
	}
	/**
	 * ページ変更時処理
	 */
	protected handleChangePage = (
		startRowIndex: number,
		endRowIndex: number
	) => {
		this.setState({ endRowIndex, startRowIndex });
	};

	/**
	 * 表示データ取得処理
	 */
	protected getDisplayData() {
		const { endRowIndex, startRowIndex } = this.state;
		const displayData = this.props.data.slice(
			startRowIndex,
			endRowIndex + 1
		);
		return displayData;
	}
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCurriculumDetail: (curriculumId: string, token: string) => {
		const s = SearchScenarioFactory.createFetchCurriculumDetail(
			dispatch,
			token
		);
		s.run(curriculumId);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
});

export interface IImstatDistanceLearningCardProps {
	data:
		| Actions.IOnGoingDistanceLearning[]
		| Actions.IResultDistanceLearning[];
	type: DistanceLearningTypes;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IImstatDistanceLearningCardProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ImstatDistanceLearningCard);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/ImstatDistanceLearningCard.tsx